import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q25',
  templateUrl: './r-q25.component.html',
  styleUrls: ['./r-q25.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ25Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  userResponses = [];
  index;
  questionObj;
  showTip = false;
  renewable;
  messagetype;
  isChecked;
  hgRenewable = {
    re_option1: false,
    re_option2: false,
    re_option3: false
  };
  deviceWidth;
  renew1_id;
  renew2_id;
  renew3_id;
  timer;
  question_q1;
  isRenewal = false;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.renew1_id = document.getElementById('renew1_mob');
      this.renew2_id = document.getElementById('renew2_mob');
      this.renew3_id = document.getElementById('renew3_mob');
    } else {
      this.renew1_id = document.getElementById('renew1');
      this.renew2_id = document.getElementById('renew2');
      this.renew3_id = document.getElementById('renew3');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        // If the flow is from renewal -> show 'renewal_question' text
        if (this.residentialService.questionFlowType === 'renewal') {
          this.question = this.questions[i].renewal_question;
          this.isRenewal = true;
        }
        this.index = i;
      }
    }
    if (this.deviceWidth > 768 && this.residentialService.questionFlowType !== 'renewal') {
      const splitQuestion = this.question.split(', ');
      this.question = splitQuestion[0] + ',';
      this.question_q1 = splitQuestion[1];
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.renewable = obj.fieldValue;
        if (!_.isEmpty(this.renewable)) {
          if (this.renewable === 'Only show renewable options') {
            this.hgRenewable = {
              re_option1: true,
              re_option2: false,
              re_option3: false
            };
            this.renew1_id.parentElement.classList.add('active-select');
          } else if (this.renewable === 'No') {
            this.hgRenewable = {
              re_option1: false,
              re_option2: true,
              re_option3: false
            };
            this.renew2_id.parentElement.classList.add('active-select');
          } else if (this.renewable === 'Yes') {
            this.hgRenewable = {
              re_option1: false,
              re_option2: false,
              re_option3: true
            };
            this.renew3_id.parentElement.classList.add('active-select');
          }
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.goNext();
          }
        }
      }
    }
    this.messagetype = this.residentialService.messervicetype;
  }

  getOption(event) {
    this.renewable = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
      if (this.renewable === 'Only show renewable options') {
          this.hgRenewable = {
            re_option1: true,
            re_option2: false,
            re_option3: false
          };
          this.renew1_id.parentElement.classList.add('active-select');
          if (_.contains(this.renew2_id.parentElement.classList, 'active-select')) {
            this.renew2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.renew3_id.parentElement.classList, 'active-select')) {
            this.renew3_id.parentElement.classList.remove('active-select');
          }
        } else if (this.renewable === 'No') {
          this.hgRenewable = {
            re_option1: false,
            re_option2: true,
            re_option3: false
          };
          this.renew2_id.parentElement.classList.add('active-select');
          if (_.contains(this.renew3_id.parentElement.classList, 'active-select')) {
            this.renew3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.renew1_id.parentElement.classList, 'active-select')) {
            this.renew1_id.parentElement.classList.remove('active-select');
          }
        } else if (this.renewable === 'Yes') {
          this.hgRenewable = {
            re_option1: false,
            re_option2: false,
            re_option3: true
          };
          this.renew3_id.parentElement.classList.add('active-select');
          if (_.contains(this.renew2_id.parentElement.classList, 'active-select')) {
            this.renew2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.renew1_id.parentElement.classList, 'active-select')) {
            this.renew1_id.parentElement.classList.remove('active-select');
          }
        }
        this.user_bot = true;
    } else {
      this.hgRenewable = {
        re_option1: false,
        re_option2: false,
        re_option3: false
      };
      this.renewable = '';
      this.user_bot = false;
      if (_.contains(this.renew1_id.parentElement.classList, 'active-select')) {
        this.renew1_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.renew2_id.parentElement.classList, 'active-select')) {
        this.renew2_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.renew3_id.parentElement.classList, 'active-select')) {
        this.renew3_id.parentElement.classList.remove('active-select');
      }
    }
    this.save();
    if (this.deviceWidth < 768) {
      this.goNext();
    }
  }

  next() {
      if (_.isEmpty(this.renewable)) {
      // console.log.log('renewable:', this.renewable);
      // alert('Select the Option');
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data, 'fieldName': 'renewable', 'fieldValue': this.renewable
    };
    this.residentialService.updateResponses(Obj);
  }

}
